// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "qliq_protobuf/auth/app_upgrade_policy.proto" (package "qliq_protobuf.auth", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message qliq_protobuf.auth.AppUpgradePolicy
 */
export interface AppUpgradePolicy {
    /**
     * @generated from protobuf field: qliq_protobuf.auth.AppUpgradePolicy.Status status = 1;
     */
    status: AppUpgradePolicy_Status;
    /**
     * @generated from protobuf field: optional int32 new_version = 2;
     */
    newVersion?: number;
    /**
     * @generated from protobuf field: optional string notice = 3;
     */
    notice?: string;
    /**
     * @generated from protobuf field: optional string link_to_new_version = 4;
     */
    linkToNewVersion?: string;
}
/**
 * @generated from protobuf enum qliq_protobuf.auth.AppUpgradePolicy.Status
 */
export enum AppUpgradePolicy_Status {
    /**
     * @generated from protobuf enum value: OK = 0;
     */
    OK = 0,
    /**
     * @generated from protobuf enum value: UPGRADE = 1;
     */
    UPGRADE = 1,
    /**
     * @generated from protobuf enum value: FORCE_UPGRADE = 2;
     */
    FORCE_UPGRADE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AppUpgradePolicy$Type extends MessageType<AppUpgradePolicy> {
    constructor() {
        super("qliq_protobuf.auth.AppUpgradePolicy", [
            { no: 1, name: "status", kind: "enum", T: () => ["qliq_protobuf.auth.AppUpgradePolicy.Status", AppUpgradePolicy_Status] },
            { no: 2, name: "new_version", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "notice", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "link_to_new_version", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message qliq_protobuf.auth.AppUpgradePolicy
 */
export const AppUpgradePolicy = new AppUpgradePolicy$Type();
